import type { Typed } from 'services/api/fields/core';

type StatusType = 'active' | 'pending';

interface LocationEpisode {
  id: string;
  episodeId: string;
  patient: {
    id: string;
    name: string;
    dateOfBirth: string;
    sex: string;
  };
  owner: {
    id: string;
    name: string;
  };
  group: {
    id: string;
    name: string;
  };
}

export interface LocationEpisodeLinkOptions {
  id: string;
  status: StatusType;
  archived: boolean;
  createdAt: string;
  updatedAt: string;
  locationEpisode?: LocationEpisode;
  [key: string]: any;
}

function getDefaults(): LocationEpisodeLinkOptions {
  return {
    id: '',
    archived: false,
    createdAt: '',
    updatedAt: '',
    status: 'pending',
    locationEpisode: {
      id: '',
      episodeId: '',
      patient: {
        id: '',
        name: '',
        dateOfBirth: '',
        sex: '',
      },
      owner: {
        id: '',
        name: '',
      },
      group: {
        id: '',
        name: '',
      },
    },
  };
}

let LocationEpisodeLink: new <T extends LocationEpisodeLinkOptions>(options: T) => Typed<_LocationEpisodeLink<T>, T>;

class _LocationEpisodeLink<T extends LocationEpisodeLinkOptions = LocationEpisodeLinkOptions> {
  id!: string;
  archived!: boolean;
  createdAt!: string;
  updatedAt!: string;
  status!: StatusType;
  locationEpisode!: LocationEpisode;

  constructor(options: T) {
    const opts = { ...getDefaults(), ...options };
    Object.assign(this, opts);

    this.id = opts.id;
    this.archived = opts.archived;
    this.createdAt = opts.createdAt;
    this.updatedAt = opts.updatedAt;
    this.status = opts.status;
    this.locationEpisode = opts.locationEpisode!;
  }

  get isActive() {
    return this.status === 'active';
  }

  get isPending() {
    return this.status === 'pending';
  }
}

// eslint-disable-next-line prefer-const
LocationEpisodeLink = _LocationEpisodeLink as typeof LocationEpisodeLink;

export default LocationEpisodeLink;
export { LocationEpisodeLink };
export type LocationEpisodeLink<T extends LocationEpisodeLinkOptions = LocationEpisodeLinkOptions> =
  _LocationEpisodeLink<T> & Omit<T, keyof _LocationEpisodeLink<T>>;
